import React, { useContext, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import { Can } from "../Can";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Menu } from "@material-ui/core";
import { DeviceHubOutlined, History, MoreVert, PictureAsPdf, Replay, SwapHorizOutlined, ViewColumnOutlined, FlagOutlined, Flag } from "@material-ui/icons";
import { v4 as uuidv4 } from "uuid";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
// import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmationModal from "../ConfirmationModal";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import BoardMoveTicketModal from "../BoardMoveTicketModal";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";
//icones
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import UndoIcon from '@material-ui/icons/Undo';
import ScheduleModal from "../ScheduleModal";
import MenuItem from "@material-ui/core/MenuItem";
import { Switch } from "@material-ui/core";
import ShowTicketOpen from "../ShowTicketOpenModal";
import { toast } from "react-toastify";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import ShowTicketLogModal from "../ShowTicketLogModal";
import TicketMessagesDialog from "../TicketMessagesDialog";
import { useTheme } from "@material-ui/styles";
const useStyles = makeStyles(theme => {
    const nt = theme.newLayoutTokens;
    return {
    actionButtons: {
        marginRight: 6,
        maxWidth: "100%",
        flex: "none",
        alignSelf: "center",
        marginLeft: "auto",
        display: "flex",
        alignItems: "center",
        "& > *": {
            margin: nt ? theme.spacing(0.5) : theme.spacing(1),
        },
    },
    bottomButtonVisibilityIcon: nt
        ? {
            padding: 7,
            color: nt.textMuted2,
            border: `1px solid ${nt.borderInput}`,
            borderRadius: nt.radii.control,
            backgroundColor: nt.surface,
            "&:hover": { backgroundColor: nt.surfaceSoft },
        }
        : {
            padding: 1,
            color: theme.mode === "light" ? '#0872b9' : '#FFF',
        },
    actionIconOn: nt
        ? {
            backgroundColor: nt.primarySoft,
            borderColor: nt.primarySofterBorder,
            color: nt.primaryText,
            "&:hover": { backgroundColor: nt.primarySoft },
        }
        : {},
    headerDivider: {
        width: 1,
        alignSelf: "stretch",
        margin: nt ? "0 4px" : 0,
        background: nt ? nt.divider : "transparent",
    },
    resolveButton: nt
        ? {
            borderRadius: nt.radii.control,
            backgroundColor: theme.palette.success.main,
            color: "#fff",
            padding: "0 14px",
            fontSize: 14,
            fontWeight: 600,
            textTransform: "none",
            "&:hover": { backgroundColor: theme.palette.success.main },
        }
        : {},
    transferButton: nt
        ? {
            borderRadius: nt.radii.control,
            border: `1px solid ${nt.borderInput}`,
            color: nt.text2,
            backgroundColor: nt.surface,
            padding: "0 14px",
            fontSize: 14,
            fontWeight: 500,
            textTransform: "none",
            "&:hover": { backgroundColor: nt.surfaceSoft },
        }
        : {},
    botoes: {
        display: "flex",
        padding: "15px",
        justifyContent: "flex-end",
        maxWidth: "100%",
        // alignItems: "center"
    }
    };
});
const SessionSchema = Yup.object().shape({
    ratingId: Yup.string().required("Avaliação obrigatória"),
});
const TicketActionButtonsCustom = ({ ticket
    // , showSelectMessageCheckbox,
    // selectedMessages,
    // forwardMessageModalOpen,
    // setForwardMessageModalOpen
}) => {
    const classes = useStyles();
    const theme = useTheme();
    const nt = theme.newLayoutTokens;
    const history = useHistory();
    const [isMounted, setIsMounted] = useState(true);
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
    const [open, setOpen] = React.useState(false);
    const formRef = React.useRef(null);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
    const [moveTicketModalOpen, setMoveTicketModalOpen] = useState(false);
    const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
    const [contactId, setContactId] = useState(null);
    const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);
    const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
    const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
    const [disableBot, setDisableBot] = useState(ticket.contact.disableBot);
    const [pendingCardId, setPendingCardId] = useState(null);
    const [pendingLoading, setPendingLoading] = useState(false);
    const canManagePending = user.profile === "admin" || user.allowPendingConfirmation === "enabled";
    const [showSchedules, setShowSchedules] = useState(false);
    const [enableIntegration, setEnableIntegration] = useState(ticket.useIntegration);
    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");
    const [logTicket, setLogTicket] = useState([]);
    const { get: getSetting } = useCompanySettings()
    const { getPlanCompany } = usePlans();
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    useEffect(() => {
        fetchData();
        // Cleanup function to set isMounted to false when the component unmounts
        return () => {
            setIsMounted(false);
        };
    }, []);
    const fetchData = async () => {
        const companyId = user.companyId;
        const planConfigs = await getPlanCompany(undefined, companyId);
        setShowSchedules(planConfigs.plan.useSchedules);
        setOpenTicketMessageDialog(false);
        setDisableBot(ticket.contact.disableBot)
        setShowTicketLogOpen(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }
    useEffect(() => {
        if (!canManagePending) return;
        (async () => {
            try {
                const { data } = await api.get(`/tickets/${ticket.id}/pending-status`);
                setPendingCardId(data.pendingCardId);
            } catch (err) {
                // silencioso - nao bloqueia o resto da tela por causa desse status
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticket.id]);

    const handleTogglePending = async () => {
        if (pendingLoading) return;
        setPendingLoading(true);
        try {
            if (pendingCardId) {
                await api.post(`/tickets/${ticket.id}/remove-from-pending`);
                setPendingCardId(null);
                toast.success("Pendência removida.");
            } else {
                const { data } = await api.post(`/tickets/${ticket.id}/send-to-pending`);
                setPendingCardId(data.pendingCardId);
                toast.success("Enviado para Pendências.");
            }
        } catch (err) {
            toastError(err);
        } finally {
            setPendingLoading(false);
        }
    };

    const handleClickOpen = async (e) => {
        const setting = await getSetting({
            "column": "requiredTag"
        });
        if (setting?.requiredTag === "enabled") {
            if (!ticket.tags || ticket.tags.length === 0) {
                toast.warning(i18n.t("messagesList.header.buttons.requiredTag"))
            } else {
                setOpen(true);
                // handleUpdateTicketStatus(e, "closed", user?.id);
            }
        } else {
            setOpen(true);
            // handleUpdateTicketStatus(e, "closed", user?.id);
        }
    };
    const handleClose = () => {
        formRef.current.resetForm();
        setOpen(false);
    };
    const handleCloseAlert = () => {
        setOpenAlert(false);
        setLoading(false);
    };
    const handleOpenAcceptTicketWithouSelectQueue = async () => {
        setAcceptTicketWithouSelectQueueOpen(true);
    };
    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(true);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };
    const handleOpenTransferModal = (e) => {
        setTransferTicketModalOpen(true);
        if (typeof handleClose == "function") handleClose();
    };
    const handleOpenConfirmationModal = (e) => {
        setConfirmationOpen(true);
        if (typeof handleClose == "function") handleClose();
    };
    const handleCloseTicketWithoutFarewellMsg = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "closed",
                userId: user?.id || null,
                sendFarewellMessage: false,
                amountUsedBotQueues: 0
            });
            setLoading(false);
            history.push("/tickets");
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };
    const handleExportPDF = async () => {
        setOpenTicketMessageDialog(true);
        handleCloseMenu();
    }
    const handleEnableIntegration = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                useIntegration: !enableIntegration
            });
            setEnableIntegration(!enableIntegration)
            setLoading(false);
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };
    const handleShowLogTicket = async () => {
        setShowTicketLogOpen(true);
    };
    const handleContactToggleDisableBot = async () => {
        const { id } = ticket.contact;
        try {
            const { data } = await api.put(`/contacts/toggleDisableBot/${id}`);
            ticket.contact.disableBot = data.disableBot;
            setDisableBot(data.disableBot)
        } catch (err) {
            toastError(err);
        }
    };
    const handleCloseTransferTicketModal = () => {
        setTransferTicketModalOpen(false);
    };
    const handleDeleteTicket = async () => {
        try {
            await api.delete(`/tickets/${ticket.id}`);
            history.push("/tickets")
        } catch (err) {
            toastError(err);
        }
    };
    const handleSendMessage = async (id) => {
        let setting;
        try {
            setting = await getSetting({
                "column": "greetingAcceptedMessage"
            })
        } catch (err) {
            toastError(err);
        }
        const msg = `${setting.greetingAcceptedMessage}`; //`{{ms}} *{{name}}*, ${i18n.t("mainDrawer.appBar.user.myName")} *${user?.name}* ${i18n.t("mainDrawer.appBar.user.continuity")}.`;
        const message = {
            read: 1,
            fromMe: true,
            mediaUrl: "",
            body: `${msg.trim()}`,
        };
        try {
            await api.post(`/messages/${id}`, message);
        } catch (err) {
            toastError(err);
        }
    };
    const handleUpdateTicketStatus = async (e, status, userId) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: status,
                userId: userId || null,
            });
            let setting;
            try {
                setting = await getSetting({
                    "column": "sendGreetingAccepted"
                })
            } catch (err) {
                toastError(err);
            }
            if (setting?.sendGreetingAccepted === "enabled" && (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled") && ticket.status === "pending") {
                handleSendMessage(ticket.id);
            }
            // if (isMounted.current) {
            setLoading(false);
            // }
            if (status === "open" || status === "group") {
                setCurrentTicket({ ...ticket, code: "#" + status });
                setTabOpen(status);
                if (history.location.pathname !== `/tickets/${ticket.uuid}`) {
                    history.push(`/tickets/${ticket.uuid}`);
                }
            } else {
                setCurrentTicket({ id: null, code: null })
                history.push("/tickets");
            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };
    const handleAcepptTicket = async (id) => {
        setLoading(true);
        try {
            const otherTicket = await api.put(`/tickets/${id}`, {
                status: ticket.isGroup ? "group" : "open",
                userId: user?.id,
            });
            if (otherTicket.data.id !== ticket.id) {
                if (otherTicket.data.userId !== user?.id) {
                    setOpenAlert(true)
                    setUserTicketOpen(otherTicket.data.user.name)
                    setQueueTicketOpen(otherTicket.data.queue.name)
                    setTabOpen(otherTicket.isGroup ? "group" : "open")
                } else {
                    setLoading(false);
                    // handleSelectTicket(otherTicket.data);
                    setTabOpen(otherTicket.isGroup ? "group" : "open")
                    history.push(`/tickets/${otherTicket.data.uuid}`);
                }
            } else {
                // if (isMounted.current) {
                setLoading(false);
                // }
                setTabOpen(ticket.isGroup ? "group" : "open");
                if (history.location.pathname !== `/tickets/${ticket.uuid}`) {
                    history.push(`/tickets/${ticket.uuid}`);
                }
            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };
    return (
        <>
            {openAlert && (
                <ShowTicketOpen
                    isOpen={openAlert}
                    handleClose={handleCloseAlert}
                    user={userTicketOpen}
                    queue={queueTicketOpen}
                />
            )}
            {acceptTicketWithouSelectQueueOpen && (
                <AcceptTicketWithouSelectQueue
                    modalOpen={acceptTicketWithouSelectQueueOpen}
                    onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
                    ticketId={ticket.id}
                    ticket={ticket}
                />
            )}
            {showTicketLogOpen && (
                <ShowTicketLogModal
                    isOpen={showTicketLogOpen}
                    handleClose={(e) => setShowTicketLogOpen(false)}
                    ticketId={ticket.id}
                />
            )}
            {openTicketMessageDialog && (
                <TicketMessagesDialog
                    open={openTicketMessageDialog}
                    handleClose={() => setOpenTicketMessageDialog(false)}
                    ticketId={ticket.id}
                />
            )}
            <div className={classes.actionButtons}>
                {ticket.status === "closed" && (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                        loading={loading}
                        startIcon={<Replay />}
                        size="small"
                        onClick={e => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                        {i18n.t("messagesList.header.buttons.reopen")}
                    </ButtonWithSpinner>
                )}
                {(ticket.status === "closed" && ticket.queueId !== null) && (
                    <ButtonWithSpinner
                        startIcon={<Replay />}
                        loading={loading}
                        onClick={e => handleAcepptTicket(ticket.id)}
                    >
                        {i18n.t("messagesList.header.buttons.reopen")}
                    </ButtonWithSpinner>
                )}
                {/* <IconButton
                    className={classes.bottomButtonVisibilityIcon}
                    onClick={handleShowLogTicket}
                >
                    <Tooltip title={i18n.t("messagesList.header.buttons.logTicket")}>
                        <History />
                    </Tooltip>
                </IconButton> */}
                {(ticket.status === "open" || ticket.status === "group") && (
                    <>
                        {/* {!showSelectMessageCheckbox ? ( */}
                        <>
                            {/* <IconButton
                                className={classes.bottomButtonVisibilityIcon}
                                onClick={handleEnableIntegration}
                            >
                                <Tooltip title={i18n.t("messagesList.header.buttons.enableIntegration")}>
                                    {enableIntegration === true ? <DeviceHubOutlined style={{ color: "green" }} /> : <DeviceHubOutlined />}
                                </Tooltip>
                            </IconButton> */}
                            <IconButton className={clsx(classes.bottomButtonVisibilityIcon, nt && disableBot && classes.actionIconOn)}>
                                <Tooltip title={i18n.t("contactModal.form.chatBotContact")}>
                                    <Switch
                                        size="small"
                                        color="primary"
                                        checked={disableBot}
                                        onChange={() => handleContactToggleDisableBot()}
                                    />
                                </Tooltip>
                            </IconButton>
                            <IconButton className={classes.bottomButtonVisibilityIcon}>
                                <Tooltip title="Mover no Quadro">
                                    <ViewColumnOutlined
                                        onClick={() => setMoveTicketModalOpen(true)}
                                    />
                                </Tooltip>
                            </IconButton>
                            {canManagePending && (
                                <IconButton className={clsx(classes.bottomButtonVisibilityIcon, nt && pendingCardId && classes.actionIconOn)} disabled={pendingLoading}>
                                    <Tooltip title={pendingCardId ? "Remover da Pendência" : "Enviar pra Pendência"}>
                                        {pendingCardId ? (
                                            <Flag htmlColor={nt ? undefined : "#f4511e"} onClick={handleTogglePending} />
                                        ) : (
                                            <FlagOutlined onClick={handleTogglePending} />
                                        )}
                                    </Tooltip>
                                </IconButton>
                            )}
                            <IconButton className={classes.bottomButtonVisibilityIcon}>
                                <Tooltip title={i18n.t("tickets.buttons.returnQueue")}>
                                    <UndoIcon
                                        onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}
                                    />
                                </Tooltip>
                            </IconButton>
                            {nt && <span className={classes.headerDivider} />}
                            {nt ? (
                                <Tooltip title="Transferir Ticket">
                                    <Button className={classes.transferButton} onClick={handleOpenTransferModal} startIcon={<SwapHorizOutlined fontSize="small" />}>
                                        Transferir
                                    </Button>
                                </Tooltip>
                            ) : (
                                <IconButton className={classes.bottomButtonVisibilityIcon}>
                                    <Tooltip title="Transferir Ticket">
                                        <SwapHorizOutlined onClick={handleOpenTransferModal} />
                                    </Tooltip>
                                </IconButton>
                            )}
                            {nt ? (
                                <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
                                    <Button className={classes.resolveButton} onClick={handleClickOpen} startIcon={<HighlightOffIcon fontSize="small" />}>
                                        Resolver
                                    </Button>
                                </Tooltip>
                            ) : (
                                <IconButton className={classes.bottomButtonVisibilityIcon}>
                                    <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
                                        <HighlightOffIcon onClick={handleClickOpen} />
                                    </Tooltip>
                                </IconButton>
                            )}
                        </>
                        {/* {showSchedules && (
                            <>
                                <IconButton className={classes.bottomButtonVisibilityIcon}>
                                    <Tooltip title={i18n.t("tickets.buttons.scredule")}>
                                        <EventIcon
                                            // color="primary"
                                            onClick={handleOpenScheduleModal}
                                        />
                                    </Tooltip>
                                </IconButton>
                            </>
                        )} */}
                        {transferTicketModalOpen && (
                            <TransferTicketModalCustom
                                modalOpen={transferTicketModalOpen}
                                onClose={handleCloseTransferTicketModal}
                                ticketid={ticket.id}
                                ticket={ticket}
                            />
                        )}
                        {moveTicketModalOpen && (
                            <BoardMoveTicketModal
                                open={moveTicketModalOpen}
                                onClose={() => setMoveTicketModalOpen(false)}
                                ticketId={ticket.id}
                            />
                        )}
                        {/* {scheduleModalOpen && (
                            <ScheduleModal
                                open={scheduleModalOpen}
                                onClose={handleCloseScheduleModal}
                                aria-labelledby="form-dialog-title"
                                contactId={contactId}
                            />
                        )} */}
                    </>
                )}
                {confirmationOpen && (
                    <ConfirmationModal
                        title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")} #${ticket.id}?`}
                        open={confirmationOpen}
                        onClose={setConfirmationOpen}
                        onConfirm={handleDeleteTicket}
                    >
                        {i18n.t("ticketOptionsMenu.confirmationModal.message")}
                    </ConfirmationModal>
                )}
                {ticket.status === "pending" && (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                        loading={loading}
                        size="small"
                        variant="contained"
                        onClick={e => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                        {i18n.t("messagesList.header.buttons.accept")}
                    </ButtonWithSpinner>
                )}
                {ticket.status === "pending" && ticket.queueId !== null && (
                    <ButtonWithSpinner
                        loading={loading}
                        size="small"
                        variant="contained"
                        // color="primary"
                        onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
                    >
                        {i18n.t("messagesList.header.buttons.accept")}
                    </ButtonWithSpinner>
                )}
                <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenu}
                    color="inherit"
                    style={{ paddingHorizontal: 3, paddingTop: 10 }}
                >
                    <MoreVert style={{ fontSize: 16, padding: 0 }} />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={menuOpen}
                    onClose={handleCloseMenu}
                >
                    <MenuItem onClick={handleOpenConfirmationModal}>
                        <Can
                            role={user.profile}
                            perform="ticket-options:deleteTicket"
                            yes={() => (
                                i18n.t("tickets.buttons.deleteTicket")
                            )}
                        />
                    </MenuItem>
                    <MenuItem onClick={handleEnableIntegration}>
                        {enableIntegration === true ? i18n.t("messagesList.header.buttons.disableIntegration") : i18n.t("messagesList.header.buttons.enableIntegration")}
                    </MenuItem>
                    <MenuItem onClick={handleShowLogTicket}>
                        {i18n.t("messagesList.header.buttons.logTicket")}
                    </MenuItem>
                    <MenuItem onClick={handleExportPDF}>
                        {i18n.t("ticketsList.buttons.exportAsPDF")}
                    </MenuItem>
                </Menu>
            </div>
            <>
                <Formik
                    enableReinitialize={true}
                    validationSchema={SessionSchema}
                    innerRef={formRef}
                    onSubmit={(values, actions) => {
                        setTimeout(() => {
                            actions.setSubmitting(false);
                            actions.resetForm();
                        }, 400);
                    }}
                >
                    {({ values, touched, errors, isSubmitting, setFieldValue, resetForm }) => (
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <Form>
                                <DialogActions className={classes.botoes}>
                                    <Button
                                        onClick={e => handleCloseTicketWithoutFarewellMsg()}
                                        style={{ background: theme.palette.primary.main, color: "white" }}
                                    >
                                        {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
                                    </Button>
                                    <Button
                                        onClick={e => handleUpdateTicketStatus(e, "closed", user?.id, ticket?.queue?.id)}
                                        style={{ background: theme.palette.primary.main, color: "white" }}
                                    >
                                        {i18n.t("messagesList.header.dialogRatingCancel")}
                                    </Button>
                                </DialogActions>
                            </Form>
                        </Dialog>
                    )}
                </Formik>
            </>
        </>
    );
};
export default TicketActionButtonsCustom;
